import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { StudentDetails } from "./routes";

export default store => ({
  path: "",
  component: withAsyncRouteLoading(() =>
    import(
      /* webpackChunkName: "transcripts-curriculum-students" */ "./components"
    ).then(m => m.default)
  ),
  indexRoute: {
    component: withAsyncRouteLoading(() =>
      import(
        /* webpackChunkName: "transcripts-curriculum-students" */ "./components"
      ).then(m => m.default)
    ),
  },
  childRoutes: [StudentDetails(store)],
});
